import { FC } from "react";
import { Lottie } from "@jugl-web/utils/utils/Lottie";
import { cx } from "@jugl-web/utils";
import { Portal } from "@headlessui/react";
import loaderAnimationData from "./assets/loader.json";

export const PageLoaderFull: FC<{
  isActive?: boolean;
  isTransparent?: boolean;
  inPortal?: boolean;
  className?: string;
}> = ({ isActive = true, isTransparent, className, inPortal = true }) => {
  if (!isActive) {
    return null;
  }
  const content = (
    <div
      className={cx(
        "fixed top-0 right-0 bottom-0 left-0 z-[10000] flex items-center justify-center",
        className
      )}
      style={{
        background: isTransparent ? "rgba(16, 17, 42, 0.38)" : "#fff",
        backdropFilter: isTransparent ? "blur(1.5px)" : undefined,
      }}
    >
      <Lottie
        options={{ animationData: loaderAnimationData }}
        height={68}
        width={68}
      />
    </div>
  );
  if (!inPortal) {
    return content;
  }
  return <Portal>{content}</Portal>;
};
